export const graphics = [];

const lrlogo =
  "data:image/svg+xml;base64,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";

export const format = (data, style, decimals, currency) => {
  data = parseFloat(data);
  const opts = {
    style: style,
    maximumFractionDigits: decimals,
    minimumFractionDigits: 0,
  };
  if (style === "currency") {
    opts.currency = currency;
  }
  return data.toLocaleString("es-CO", opts);
};

export const getBackgroundCanvas = () => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = canvas.height = 440;
  ctx.translate(0, 50);
  // ctx.rotate(-Math.PI / 16);
  const base_image = new Image();
  base_image.src = "https://s.lalr.co/wg/images/logolr-alpha.svg";
  base_image.onload = function () {
    ctx.drawImage(base_image, 0, 0, 70, 90);
    ctx.drawImage(base_image, 140, 180, 70, 90);
    ctx.drawImage(base_image, 280, 360, 70, 90);
  };
  return canvas;
};

export const setBgGraphic = (name) => {
  const offset = 250;
  const wi = Math.ceil(graphics[name].getWidth() / offset);
  const h = Math.ceil(graphics[name].getHeight() / offset);
  const a = Array.from(Array(wi * h).keys());
  graphics[name].setOption({
    graphic: a.map(function (_v, idx) {
      const div = Math.floor(idx / wi);
      const res = idx % wi;
      return {
        id: "img-" + idx,
        type: "image",
        left: offset * res + (div % 2 ? offset / 2 : 0),
        top: offset * div + (res % 2 ? offset / 2 : 0),
        style: {
          image: lrlogo,
          width: 80,
          height: 100,
          opacity: 0.05,
        },
        silent: true,
        // ignore: true,
      };
    }),
  });
};

export const setCaption = (name, text) => {
  graphics[name].setOption({
    graphic: {
      type: "group",
      rotation: Math.PI / 2,
      bounding: "raw",
      right: 0,
      bottom: '50%',
      z: 100,
      children: [
        {
          type: "text",
          left: "center",
          top: "bottom",
          z: 100,
          style: {
            fill: "#000",
            text: text,
            font: 'bold 10px "Montserrat"',
          },
        },
      ],
    },
  });
};

export const resizeGraphs = () => {
  for (const graph in graphics) {
    graphics[graph].resize();
  }
};

setTimeout(resizeGraphs, 1000);
window.addEventListener("resize", resizeGraphs);
